/**
 * @description Can be swapped with the primary success color.
 */

const greenLight = {
  25: "#FAFEF5",
  50: "#F3FEE7",
  100: "#E4FBCC",
  200: "#D0F8AB",
  300: "#A6EF67",
  400: "#85E13A",
  500: "#66C61C",
  600: "#4CA30D",
  700: "#3B7C0F",
  800: "#326212",
  900: "#2B5314",
  950: "#15290A",
};

export default greenLight;
